import type { JSX } from "react";

import { Popover as BasePopover } from "@base-ui/react/popover";

import type { PopoverProps } from "./Popover.types";

export function Popover<Payload = unknown>({
  ...props
}: PopoverProps<Payload>): JSX.Element {
  return <BasePopover.Root data-slot="popover" {...props} />;
}
